export const BTN_PRIMARY =
  'inline-flex h-12 items-center justify-center gap-2 bg-accent px-7 font-mono text-[11px] font-medium uppercase tracking-[0.22em] text-white border border-accent transition-colors duration-200 hover:bg-accent2 hover:border-accent2 disabled:opacity-50 disabled:pointer-events-none';

export const BTN_SECONDARY =
  'inline-flex h-12 items-center justify-center gap-2 border border-line bg-transparent px-7 font-mono text-[11px] font-medium uppercase tracking-[0.22em] text-white transition-colors duration-200 hover:border-silver disabled:opacity-50 disabled:pointer-events-none';

export const EYEBROW =
  'font-mono text-[11px] font-medium uppercase tracking-[0.3em] text-accentText';

export const LINK_ARROW =
  'inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-white border-b border-line pb-1 transition-colors hover:border-accent hover:text-white';

export const INPUT =
  'h-12 w-full border border-neutral-300 bg-white px-4 text-base text-neutral-900 placeholder:text-neutral-400 outline-none transition-colors focus:border-accent';

export const LABEL =
  'block font-mono text-[10px] font-medium uppercase tracking-[0.25em] text-dim mb-2';
